<template>
  <div
    class="onboarding-layout"
    :class="{ 'onboarding-layout--scroll-default-slot': scrollDefaultSlot }"
  >
    <div class="onboarding-layout__above-title">
      <slot name="aboveTitle"></slot>
    </div>

    <div
      v-if="title || subtitle"
      class="onboarding-layout__text"
      :class="{ 'onboarding-layout__text--reverse': reverseTitleSubtitle }"
    >
      <transition
        :name="titleTransition ? 'fade' : undefined"
        :mode="titleTransition ? 'out-in' : undefined"
      >
        <h1
          v-if="title"
          :key="titleTransition ? title : undefined"
          class="onboarding-layout__title wg-no-merge"
          v-html="title"
        ></h1>
      </transition>
      <transition
        :name="subtitleTransition ? 'fade' : undefined"
        :mode="subtitleTransition ? 'out-in' : undefined"
      >
        <p
          v-if="subtitle"
          :key="subtitleTransition ? subtitle : undefined"
          class="onboarding-layout__subtitle"
          v-html="subtitle"
        ></p>
      </transition>
    </div>

    <div class="onboarding-layout__default-slot">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  subtitle?: string
  scrollDefaultSlot?: boolean
  titleTransition?: boolean
  subtitleTransition?: boolean
  reverseTitleSubtitle?: boolean
}>()
</script>

<style lang="scss" scoped>
.onboarding-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 100%;
  padding: var(--onboarding-padding);
  padding-bottom: calc(var(--onboarding-padding) * 2);
  overflow-y: auto;

  &__above-title,
  &__default-slot {
    width: 100%;

    :deep(> *:not(.rive)) {
      width: 100%;
      max-width: var(--onboarding-inner-width);
      margin-inline: auto;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: var(--onboarding-outer-width);

    &--reverse {
      flex-direction: column-reverse;
    }
  }

  &__title {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.02em;
    text-align: center;
    text-wrap: balance;
    color: $c-black-2;
    font-weight: 500;
    @media (min-width: $w-medium-b) {
      font-size: 32px;
      line-height: 40px;
    }
  }

  &__subtitle {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: $c-black-3;
  }
}

.onboarding-layout--scroll-default-slot {
  padding-bottom: 0;

  .onboarding-layout {
    &__default-slot {
      height: 100%;
      padding-bottom: calc(var(--onboarding-padding) * 2);
      overflow-y: auto;
    }
  }
}
</style>
